import { setRelatedResources } from '../../utils/functions.utils'

export const setResourceMaps = (allAdditionalResources: any) => {
  const resourceProducts = new Map()
  const resourceTopics = new Map()
  const resourceIndustry = new Map()
  const resourceDepartment = new Map()

  for (let i = 0; i < allAdditionalResources.length; i++) {
    if (allAdditionalResources[i].node) {
      let resource = allAdditionalResources[i].node

      const metaInformation = resource.metaInformation || []
      const topics = resource.topics || []
      const allTags = [...metaInformation, ...topics]

      for (let j = 0; j < allTags.length; j++) {
        if (allTags[j]?.__typename) {
          if (allTags[j].__typename === 'ContentfulTopicResourceIndustry') {
            resourceIndustry.has(allTags[j].id)
              ? resourceIndustry.set(allTags[j].id, [
                  ...resourceIndustry.get(allTags[j].id),
                  resource,
                ])
              : resourceIndustry.set(allTags[j].id, [resource])
          } else if (allTags[j].__typename === 'ContentfulTopicResourceDepartment') {
            resourceDepartment.has(allTags[j].id)
              ? resourceDepartment.set(allTags[j].id, [
                  ...resourceDepartment.get(allTags[j].id),
                  resource,
                ])
              : resourceDepartment.set(allTags[j].id, [resource])
          } else if (allTags[j].__typename === 'ContentfulTopicResourceTopic') {
            resourceTopics.has(allTags[j].id)
              ? resourceTopics.set(allTags[j].id, [...resourceTopics.get(allTags[j].id), resource])
              : resourceTopics.set(allTags[j].id, [resource])
          } else if (allTags[j].__typename === 'ContentfulTopicResourceProduct') {
            resourceProducts.has(allTags[j].id)
              ? resourceProducts.set(allTags[j].id, [
                  ...resourceProducts.get(allTags[j].id),
                  resource,
                ])
              : resourceProducts.set(allTags[j].id, [resource])
          }
        }
      }
    }
  }

  return {
    resourceProducts,
    resourceTopics,
    resourceIndustry,
    resourceDepartment,
  }
}

export const sortResources = (allAdditionalResources: any) => {
  allAdditionalResources.sort(function (a: any, b: any) {
    var date1 = new Date(a.node.date)
    var date2 = new Date(b.node.date)
    if (date2 < date1) {
      return -1
    } else if (date1 == date2) {
      return 0
    } else {
      return 1
    }
  })
}

export const filterTeasers = (allContentfulTeasers: any) => {
  if (allContentfulTeasers?.edges) {
    const brochureEx: any = []
    const onDemandWebinerEX: any = []
    allContentfulTeasers.edges.forEach((edge: any) => {
      let seen = false
      if (edge.node?.category?.title === 'Brochure') {
        brochureEx.push(edge)
        seen = true
      }
      if (edge.node.metaInformation && edge.node.metaInformation.length > 0) {
        edge.node.metaInformation.forEach((meta: any) => {
          if (
            meta?.__typename === 'ContentfulTopicWebinarType' &&
            meta?.title === 'On-Demand' &&
            seen === false
          ) {
            onDemandWebinerEX.push(edge)
          }
        })
      }
    })
    return [...brochureEx, ...onDemandWebinerEX]
  } else {
    return []
  }
}

export const getPageResources = (
  allContentfulComponentThankYouFeaturedResource: any,
  thankYouPageData: any,
  resourceProducts: any,
  resourceTopics: any,
  resourceIndustry: any,
  resourceDepartment: any
) => {
  let thankYouFeaturedResourceData, thankYouFeaturedResource
  let slug = ''
  const seen = new Set()
  const referrer = thankYouPageData.referrer || {}
  const pageLocale = thankYouPageData.node_locale
  const relatedResources: any = []
  const referrerTopics = referrer.topics || []
  const referrerMetaInformation = referrer.metaInformation || []
  const referrerAllTags = [...referrerMetaInformation, ...referrerTopics]

  slug = thankYouPageData.slug
    ? `${thankYouPageData.slug ? thankYouPageData.slug : ''}`
    : `/g/thank-you-${
        thankYouPageData.pageName ? thankYouPageData.pageName.split(' ').join('-') : ''
      }`

  if (allContentfulComponentThankYouFeaturedResource?.edges) {
    thankYouFeaturedResourceData = allContentfulComponentThankYouFeaturedResource.edges
  }
  if (
    thankYouFeaturedResourceData &&
    thankYouFeaturedResourceData.length &&
    thankYouFeaturedResourceData.length > 1
  ) {
    const today = new Date()

    for (let n = 0; n < thankYouFeaturedResourceData.length; n++) {
      if (
        thankYouFeaturedResourceData[n].node?.node_locale !== pageLocale ||
        referrer.id === thankYouFeaturedResourceData[n].node?.resource?.id
      )
        continue
      if (thankYouFeaturedResource) break
      const unpublishDate = thankYouFeaturedResourceData[n].node.unpublishDate
        ? thankYouFeaturedResourceData[n].node.unpublishDate
        : undefined
      if (unpublishDate) {
        const expiration = new Date(unpublishDate)
        if (expiration > today) {
          thankYouFeaturedResource = thankYouFeaturedResourceData[n].node
          break
        }
      }
    }
  } else {
    thankYouFeaturedResource = thankYouFeaturedResourceData
  }
  // prioritize the resources that are related to the referrer
  // Analyst Reports => topic-ResourceProduct > topic-ResourceTopic > topic-ResourceDepartment > topic-ResourceIndustry
  // Everything else => topic-ResourceDepartment > topic-ResourceIndustry > topic-ResourceProduct > topic-ResourceTopic
  if (thankYouPageData.resourceCategory?.title === 'Analyst Report') {
    // resourceProducts
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceProducts.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceProducts.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: true,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }

    // resourceTopics
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceTopics.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceTopics.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: true,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }

    // check resource department
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceDepartment.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceDepartment.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: true,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }
    // check resource industry
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceIndustry.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceIndustry.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: true,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }
  } else {
    // check resource department
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceDepartment.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceDepartment.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: true,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }

    // check resource industry
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceIndustry.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceIndustry.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: true,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }

    // resourceProducts
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceProducts.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceProducts.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: true,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }

    // resourceTopics
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceTopics.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceTopics.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: true,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }
  }
  // 2nd loop to add the rest of the resources that are not featured
  // prioritize the resources that are related to the referrer
  // Analyst Reports => topic-ResourceProduct > topic-ResourceTopic > topic-ResourceDepartment > topic-ResourceIndustry
  // Everything else => topic-ResourceDepartment > topic-ResourceIndustry > topic-ResourceProduct > topic-ResourceTopic
  if (thankYouPageData.resourceCategory?.title === 'Analyst Report') {
    // resourceProducts
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceProducts.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceProducts.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: false,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }

    // resourceTopics
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceTopics.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceTopics.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: false,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }

    // check resource department
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceDepartment.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceDepartment.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: false,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }
    // check resource industry
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceIndustry.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceIndustry.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: false,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }
  } else {
    // check resource department
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceDepartment.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceDepartment.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: false,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }

    // check resource industry
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceIndustry.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceIndustry.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: false,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }

    // resourceProducts
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceProducts.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceProducts.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: false,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }

    // resourceTopics
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceTopics.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceTopics.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: false,
          resourceLocale: referrer.entryLocale,
        })
      }

      if (relatedResources.length === 3) break
    }
  }

  return [relatedResources, thankYouFeaturedResource]
}
